var exports = {
  "container": "x43cbe9c2--c24d0e--container",
  "page": "x43cbe9c2--c24d0e--page",
  "little": "x43cbe9c2--c24d0e--little",
  "title": "x43cbe9c2--c24d0e--title",
  "main-banner": "x43cbe9c2--c24d0e--main-banner",
  "house": "x43cbe9c2--c24d0e--house",
  "second-banner": "x43cbe9c2--c24d0e--second-banner",
  "text-block": "x43cbe9c2--c24d0e--text-block",
  "btn": "x43cbe9c2--c24d0e--btn",
  "image": "x43cbe9c2--c24d0e--image",
  "cian-pin": "x43cbe9c2--c24d0e--cian-pin",
  "cian-calendar": "x43cbe9c2--c24d0e--cian-calendar",
  "keys": "x43cbe9c2--c24d0e--keys",
  "chair": "x43cbe9c2--c24d0e--chair",
  "smb-pre-footer": "x43cbe9c2--c24d0e--smb-pre-footer",
  "tablet": "x43cbe9c2--c24d0e--tablet",
  "phone": "x43cbe9c2--c24d0e--phone",
};

module.exports = exports;
